import { axios, Response } from '../index'

const fixPost = (
  personaId: string,
  postId: number,
  data: {
    date: string | null
  }
): Response<void> => {
  return axios.put(`/v1/personas/${personaId}/posts/${postId}/pin-post`, data)
}

export default fixPost
